import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { UretimSayacEditComponent } from './uretim-sayac-edit.component';
import { UretimSayacKartComponent } from './uretim-sayac-kart.component';
import { UretimSayacKartSadeComponent } from './uretim-sayac-kart-sade.component';

@DinamikBilesen({
  id: 'uretim-sayac',
  baslik: 'Üretim Sayacı',
  aciklama: 'Tezgah üretim takibi',
  ikon: 'bar-chart',
  kategori: 'uretim',
})
class UretimSayac {
  paylas_kutusu = UretimSayacEditComponent;
  paylasilmis_kart = UretimSayacKartComponent;
  paylasilmis_kart_sade = UretimSayacKartSadeComponent;
}
